<template>
  <Calculator />
  <Foot />
</template>

<script>
import Calculator from './components/Calculator.vue';
import Foot from './components/Foot.vue';

export default {
  name: 'App',
  components: {
    Calculator,
    Foot,
  },
};
</script>

<style>
body {
  background: #fff url('./assets/images/body-app.jpg') 50% 0 no-repeat;
}

ul {
  list-style: none;
}

p {
  font: normal 1.5em/18px Arial, Helvetica, sans-serif;
  font-size: 1.5em;
  letter-spacing: -0.017em;
  padding: 0 0 20px;
}

body,
h1,
h2,
h3,
h4,
h5,
h6,
p,
dl,
dt,
dd,
ul,
ol,
li,
th,
td,
form,
fieldset,
legend,
label,
input,
textarea,
select,
option,
button,
blockquote {
  margin: 0;
  padding: 0;
}

body {
  font: normal 62.5%/1 Arial, Helvetica, sans-serif;
  color: #555957;
}

h2 {
  font-family: 'AlgreSansNCRegular';
  font-size: 2em;
  padding: 5px 0;
  height: 28px;
  margin: 0 0 18px;
  background: url(./assets/images/title.png) 0 0 no-repeat;
  color: #fff;
  float: left;
  width: 100%;
  letter-spacing: 0.01em;
}

@font-face {
  font-family: 'AlgreSansNCBold';
  src: url('../public/alegre_sans_bold_nc_slo-webfont.svg') format('svg');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'AlgreSansNCRegular';
  src: url('../public/alegre_sans_regular_nc_slo-webfont.svg') format('svg');
  font-weight: normal;
  font-style: normal;
}
</style>
